<template>
  <div class="centerBox">
    <div class="about centBoxIn">
      <div class="aboutIn">
        <div class="abountBtn">公司简介</div>
        <div class="title">股宇宙数据库</div>
        <div class="aboutCont">
          <div class="aboutTxt">
            股宇宙数据库（Stock UniverseDatabase）是一家专注于金融数据库技术研发、数据重生、数据整理、数据建模、数据训练的科技金融企业，致力于通过前沿数据技术开发出新一代金融数据库底座模方，构建更智能、更理性、更科学的投资数据堆叠支持。自主研发金融全息串链分析数据库与模方算法AI技术，同时创新开发出数据库“模方”系统，超强赋能新一代投资人，聚合时代数据洪荒之力，数造应用典范。
            <p>数据库愿景：让数据为人类奔跑</p> 
            <p>数据库核心技术优势：</p>
            <p>1、数据库底座堆叠驱动的黑土地量化效应；</p>
            <p>2、金融全息串链分析数据库驱动的AI服务；</p>
            <p>3、模方算法AI技术驱动的零和博弈；</p>
            <p>4、数据模方驱动的训练学院（Zhibiao Academy）；</p>
            <p class="noWrap">5、组合模方驱动的投资引擎价值（Universe Model Square）。</p>
          </div>
          <div class="aboutImgBox">
            <img src="../../common/images/about/about.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
};
</script>

<style scoped>
.about {
  width: 100%;
  background-color: #f3f5f9;
}
.aboutIn {
  margin: 0 auto;
  padding: 21px 20px 0;
  box-sizing: border-box;
  width: var(--content-width);
  min-width: var(--content-min-width);
}
.aboutIn .abountBtn {
  width: 144px;
  height: 41px;
  font-weight: 600;
  font-size: 26px;
  background-image: url("../../common/images/other/title_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  color: #318af9;
}

.aboutIn .aboutCont {
  display: flex;
  justify-content: space-between;
  padding-bottom: 141px;
  box-sizing: border-box;
  width: 100%;
}
.aboutIn .title {
  padding: 121px 0 38px;
  font-weight: 800;
  font-size: 29px;
  color: #1a1a1a;
  text-align: left;
  padding-bottom: 38px;
}

.aboutIn .aboutCont .aboutTxt {
  font-weight: 500;
  font-size: 21px;
  color: #4d4d4d;
  text-align: left;
  padding-right: 75px;
  box-sizing: border-box;
  flex: 1;
}
.aboutIn .aboutCont .aboutImgBox {
  flex: 1;
}
.aboutIn .aboutCont .aboutImgBox img {
  width: 100%;
}
.noWrap {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue